<template>
  <div class="all-box content-box content-container" ref="contentContainer">
    <Header :scrollPosition="scrollPosition" />
    <section
      class="dzclubs-all-wrap"
      style="padding: 0; background-color: #fff"
    >
      <div class="content-intro-box">
        <div class="content-img-wrap">
          <el-carousel
            :interval="setTime"
            indicator-position="none"
            arrow="never"
            height="100%"
            v-if="contentData.length > 1"
          >
            <el-carousel-item v-for="(item, key) in contentData" :key="key">
              <img :src="item.img" style="object-fit: contain" alt="" />
            </el-carousel-item>
            <img :src="contentData[0].img" class="contentImgZhan" alt="" />
          </el-carousel>
          <img
            src="@/assets/sw/dfmz/dfmz2.png"
            style="object-fit: contain"
            alt=""
            v-else
          />
          <div class="indicator-box abs" v-if="contentData.length > 1">
            <div class="indicator-num-box">
              {{ itemKey }}
            </div>
            <div style="margin: 0 2px">/</div>
            <div>{{ contentData.length }}</div>
          </div>
        </div>
      </div>
      <div class="content-info-box">
        <div class="content-display-wrap">
          <el-row
            justify="space-between"
            :align="'middle'"
            class="content-display-item-price"
          >
            <el-col :span="24">
              <el-text tag="b" class="price">99元</el-text>
              <el-text type="info" tag="del" size="small" class="oprice"
                >199元</el-text
              >
            </el-col>
          </el-row>
          <el-row class="content-display-item-title">
            <el-col :span="24">
              <el-text size="large" tag="p">{{ swContentTitle }}</el-text>
            </el-col>
          </el-row>
          <img
            src="@/assets/yiduihuan.png"
            class="ydh_img abs"
            alt=""
            v-if="swContentData[0].contentStatus == 2"
          />
        </div>
        <div class="content-display-wrap">
          <el-row
            justify="space-between"
            :align="'middle'"
            class="content-display-title"
          >
            <el-col :span="24">
              <el-text size="large">权益提供方</el-text>
            </el-col>
          </el-row>
          <el-row class="content-display-item">
            <el-col :span="6" class="content-item-desc">
              <el-text tag="p" type="info">联系方式</el-text>
            </el-col>
            <el-col :span="18">
              <el-text tag="p">咨询服务热线：021-62474929（9点-17点）</el-text>
            </el-col>
          </el-row>
        </div>
        <div class="content-display-wrap">
          <el-row
            justify="space-between"
            :align="'middle'"
            class="content-display-title"
          >
            <el-col :span="24">
              <el-text size="large">权益须知</el-text>
            </el-col>
          </el-row>
          <el-row class="content-display-item">
            <el-col :span="6" class="content-item-desc">
              <el-text tag="p" type="info">注意事项</el-text>
            </el-col>
            <el-col :span="18" class="content-item-text">
              <el-text tag="p">
                尊敬的新民晚报读者俱乐部用户（以下简称“俱乐部”），欢迎您兑换VIP用户权益，请您仔细阅读以下内容，确认后提交：
              </el-text>
              <el-text tag="p">
                为保障您的安全、合法权益，请您准确填写登塔人身份证信息。登塔实名购票时将再一次核验，如复核不一致，您将无法兑换99元登塔权益。
              </el-text>
              <el-text tag="p"
                >报刊订阅期内，每名俱乐部VIP用户仅限兑换东方明珠99元登塔权益一次。</el-text
              >
              <el-text tag="p"
                >读者权益为实名制，不得转让、倒卖、不兑换现金、非正常渠道获取视为非法持有，将不予承兑。
              </el-text>
            </el-col>
          </el-row>
        </div>

        <div class="content-display-wrap">
          <el-row
            justify="space-between"
            :align="'middle'"
            class="content-display-title"
          >
            <el-col :span="24">
              <el-text size="large">{{
                swContentData[0].contentStatus == 0
                  ? "填写信息"
                  : "登塔人员信息"
              }}</el-text>
            </el-col>
          </el-row>
          <el-row
            class="content-display-item content-bm-input userinfo-bm-input"
            v-if="swContentData[0].contentStatus == 0"
          >
            <el-col :span="24">
              <el-form
                :model="userContentForm"
                label-width="80px"
                :label-position="labelPosition"
                :rules="rules"
                ref="userContentForm"
                hide-required-asterisk
              >
                <div class="userinfo-input">
                  <el-form-item label="姓名" prop="realname">
                    <el-input
                      v-model="userContentForm.realname"
                      placeholder="请填写姓名"
                      maxlength="45"
                      clearable
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="userinfo-input">
                  <el-form-item label="身份证" prop="passport">
                    <el-input
                      v-model="userContentForm.passport"
                      placeholder="请填写身份证号码"
                      maxlength="18"
                      clearable
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="content-btn-box">
                  <el-button
                    type="danger"
                    @click="canShowDialog('userContentForm')"
                    :disabled="canSubmit"
                    class="contentSubmit"
                    >提交
                  </el-button>
                </div>
              </el-form>
            </el-col>
          </el-row>

          <el-row
            class="content-display-item userinfo-bm-input content-user-info-input"
            v-else
          >
            <el-col :span="24">
              <div class="userinfo-input">
                <p class="showRealname">
                  {{ swContentData[0].contentRealname }}
                </p>
              </div>
              <div class="userinfo-input">
                <p class="showPassport">
                  {{ swContentData[0].contentPassport }}
                </p>
              </div>
              <div style="text-align: center">
                <el-text tag="b" type="danger" size="large"
                  >请携带登记身份证 现场购票登塔</el-text
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
    <div class="allDialog">
      <el-dialog
        title="核对人员信息"
        v-model="showDialog"
        width="90%"
        top="36vh"
        :show-close="false"
        :close-on-click-modal="false"
        center
      >
        <el-row
          justify="space-between"
          :align="'middle'"
          class="content-vail-wrap"
        >
          <el-col :span="24">
            <el-row
              justify="space-between"
              :align="'middle'"
              class="content-vail-items"
            >
              <Transition name="fade">
                <el-col :span="6" class="vail-item" v-if="showVail">
                  <el-text tag="p">姓名：</el-text>
                </el-col>
              </Transition>

              <Transition name="fade2">
                <el-col :span="18" class="vail-item" v-if="showVail">
                  <el-text tag="p" truncated>{{
                    userContentForm.realname
                  }}</el-text>
                </el-col>
              </Transition>
            </el-row>
          </el-col>

          <el-col :span="24">
            <el-row
              justify="space-between"
              :align="'middle'"
              class="content-vail-items"
            >
              <Transition name="fade4">
                <el-col :span="6" class="vail-item" v-if="showVail">
                  <el-text tag="p">身份证：</el-text>
                </el-col>
              </Transition>

              <Transition name="fade5" @after-enter="textAfterEnter">
                <el-col :span="18" class="vail-item" v-if="showVail">
                  <el-text tag="p">{{ userContentForm.passport }}</el-text>
                </el-col>
              </Transition>
            </el-row>
          </el-col>

          <el-col :span="24" style="padding-top: 10px">
            <el-text type="warning" size="large" tag="b"
              >兑换权益前，请您再次核对身份信息</el-text
            >
          </el-col>
        </el-row>
        <template #footer>
          <Transition name="fade7" @after-enter="afterEnter">
            <div class="dialog-footer" v-if="showVail2">
              <el-button
                @click="
                  showDialog = false;
                  showVail = false;
                  showVail2 = false;
                  showVailBtn = true;
                "
                :disabled="showVailBtn"
                >取 消
              </el-button>
              <el-button @click="dfmzJoin" :disabled="showVailBtn"
                >确 认</el-button
              >
            </div>
          </Transition>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Header from "@/components/util/Header";
import { titleController } from "@/utils";

import qs from "qs";

export default {
  name: "ShangWuContent",
  data() {
    return {
      title: "",
      wx: {
        uid: 0,
        openid: "",
        nickname: "",
        headimgurl: "",
        userToken: "",
      },
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      contentName: "dfmz",
      contentData: [
        {
          img: require("@/assets/sw/dfmz/dfmz2.png"),
        },
      ],
      swContentTitle: "东方明珠（二球观光）",
      bannerHeight: 0,
      setTime: 5000,
      itemKey: 1,
      labelPosition: "left",
      userContentForm: {
        realname: "",
        passport: "",
      },
      swContentData: [
        {
          contentStatus: 0,
          contentRealname: "",
          contentPassport: 0,
        },
      ],
      rules: {
        realname: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
        ],
        passport: [
          { required: true, message: "身份证号码不能为空", trigger: "blur" },
        ],
      },
      scrollPosition: 0,
      canSubmit: false,
      showDialog: false,
      showVail: false,
      showVail2: false,
      showVailBtn: true,
      storage: window.localStorage,
    };
  },
  created() {
    this.hasContentName(this.contentName);
  },
  mounted() {
    this.wx.uid = this.storage.getItem("uid");
    this.wx.userToken = this.storage.getItem("usertoken");
    this.getUserInfo();
    this.setItemKey();
    this.handleScroll();
    titleController.setRouteTitle(this.swContentTitle);
  },
  methods: {
    hasContentName(contentName) {
      if (contentName != this.$route.params.name) {
        this.$router.push({
          name: "NotFound",
        });
      }
    },
    setItemKey() {
      setInterval(() => {
        this.itemKey++;
        if (this.itemKey > this.contentData.length) {
          this.itemKey = 1;
        }
      }, this.setTime);
    },
    handleScroll() {
      // 获取滚动位置
      const contentContainer = this.$refs.contentContainer;
      contentContainer.addEventListener("scroll", () => {
        var currentScrollPos = contentContainer.scrollTop;
        // 检测滚动条是否已经远离顶部
        if (currentScrollPos > 0) {
          this.scrollPosition = currentScrollPos;
        } else {
          this.scrollPosition = 0;
        }
      });
    },
    canShowDialog(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.showDialog = true;
          setTimeout(() => {
            this.showVail = true;
          }, 500);
        } else {
          return false;
        }
      });
    },
    dfmzJoin() {
      this.$axios
        .post(
          `/wxindex/user/dfmzedit.html`,
          qs.stringify({
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
            dongfmz_realname: this.userContentForm.realname,
            passport: this.userContentForm.passport,
          })
        )
        .then((response) => {
          if (response.data.status) {
            this.canSubmit = true;
            this.showVailBtn = true;
            this.$message.success({
              message: response.data.message,
              type: "success",
              center: true,
              offset: 90,
              duration: 1500,
              customClass: "message-class",
            });
            setTimeout(() => {
              this.$router.push({
                name: "Equity",
              });
            }, 1500);
          } else {
            this.canSubmit = true;
            this.showVailBtn = true;
            this.$message.warning({
              message: response.data.message,
              type: "warning",
              center: true,
              offset: 90,
              duration: 1500,
              customClass: "message-class",
            });
            setTimeout(() => {
              this.canSubmit = false;
              this.showVailBtn = false;
            }, 1500);
          }
        });
    },
    getUserInfo() {
      this.$axios
        .get(`/wxindex/user/getinfo.html`, {
          params: {
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.swContentData[0].contentStatus =
              response.data.userinfo.dongfmz;
            this.swContentData[0].contentRealname =
              response.data.userinfo.dongfmz_realname;
            this.swContentData[0].contentPassport =
              response.data.userinfo.passport;
          } else {
            window.location.href =
              "https://clubs.xinmin.cn/dzclub/index.html#/auth";
          }
        });
    },
    afterEnter() {
      this.showVailBtn = false;
    },
    textAfterEnter() {
      this.showVail2 = true;
    },
  },
  components: {
    Header,
  },
};
</script>

<style scoped>
.content-container {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
}
.content-img-wrap {
  position: relative;
}

.indicator-box {
  display: -webkit-flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  width: max-content;
  bottom: 15px;
  right: 2%;
  padding: 5px 10px;
  font-size: 14px;
  color: var(--fff);
  background-color: var(--content-indicator-black-05);
  border-radius: 15px;
  line-height: 1;
}

.contentImgZhan {
  display: block;
  height: 100%;
  object-fit: contain;
  opacity: 0;
  pointer-events: none;
}

.content-info-box {
  width: 96%;
  margin: auto;
}

.content-display-wrap {
  position: relative;
  width: 100%;
  margin: 10px auto;
  padding: 10px 0;
  border-radius: 15px;
  overflow: hidden;
  background-color: var(--fff);
}

.content-display-item-price {
  text-align: left;
  margin: auto;
  width: 90%;
  line-height: 1.4;
}

.content-display-item-price b {
  font-size: 20px;
  color: var(--zfMsg-publish);
}

.content-display-item-price .oprice {
  padding-left: 10px;
}

.content-display-item-title {
  width: 90%;
  margin: 0 auto;
  text-align: left;
  line-height: 1.4;
}

.content-display-title {
  text-align: left;
  margin: auto;
  width: 90%;
  line-height: 1.4;
}

.content-display-item {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
  text-align: justify;
  line-height: 1.4;
}

.content-item-desc {
  font-size: 16px;
  line-height: 1.4;
}

.content-item-text p:first-child,
.content-item-text p:last-child {
  margin: 0 auto;
}

.content-item-text p {
  margin: 10px auto;
}

.content-btn-box {
  width: 55%;
  margin: auto;
  padding: 10px 0;
}

.contentSubmit {
  width: 100%;
}

.content-bm-input .userinfo-input {
  padding-bottom: 20px;
}

.vail-item {
  margin: 10px auto;
}

.fade-enter-active,
.fade-leave-active,
.fade2-enter-active,
.fade2-leave-active,
.fade3-enter-active,
.fade3-leave-active,
.fade4-enter-active,
.fade4-leave-active,
.fade5-enter-active,
.fade5-leave-active,
.fade6-enter-active,
.fade6-leave-active,
.fade7-enter-active,
.fade7-leave-active {
  -webkit-transition: opacity 1s linear;
}

.fade2-enter-active {
  -webkit-transition-delay: 0.5s;
}

.fade3-enter-active {
  -webkit-transition-delay: 1s;
}

.fade4-enter-active {
  -webkit-transition-delay: 1.5s;
}

.fade5-enter-active {
  -webkit-transition-delay: 2s;
}

.fade6-enter-active {
  -webkit-transition-delay: 2.5s;
}

.fade-enter-from,
.fade-leave-to,
.fade2-enter-from,
.fade2-leave-to,
.fade3-enter-from,
.fade3-leave-to,
.fade4-enter-from,
.fade4-leave-to,
.fade5-enter-from,
.fade5-leave-to,
.fade6-enter-from,
.fade6-leave-to,
.fade7-enter-from,
.fad7-leave-to {
  opacity: 0;
}

.showRealname,
.showPassport {
  --el-tag-bg-color: var(--el-fill-color-blank);
  --el-tag-border-color: var(--el-color-info-light-5);
  --el-tag-hover-color: var(--el-color-info);
  --el-tag-text-color: var(--el-color-info);
  background-color: var(--el-tag-bg-color);
  border-color: var(--el-tag-border-color);
  color: var(--el-tag-text-color);
  display: block;
  vertical-align: middle;
  font-size: 16px;
  border-width: 1px;
  border-style: solid;
  line-height: 1.5;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.content-user-info-input .userinfo-input {
  border-top: 0;
}

.ydh_img {
  right: 5%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  width: 18%;
}
</style>